import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { stripAccountPrefix } from '../../constants/permissions';

export const RedirectWithoutAccountPrefix = () => {
  const { pathname, search } = useLocation();
  const next = stripAccountPrefix(pathname);
  return <Navigate to={`${next}${search}`} replace />;
};

const LegacyRedirect = () => {
  const { accounts, canAccessAllAccounts } = useAuth();
  const { pathname, search } = useLocation();

  const list = Array.isArray(accounts) ? accounts : [];
  if (!canAccessAllAccounts && list.length === 1 && list[0]?.hubSpotId) {
    return (
      <Navigate
        to={`/${list[0].hubSpotId}${pathname}${search}`}
        replace
      />
    );
  }

  return <Navigate to="/accounts" replace />;
};

export default LegacyRedirect;
